import React from 'react';
import { Box, Button } from '@mui/material';
import {
  ArrowForward as ArrowForwardIcon,
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';

export const StepNavigation: React.FC<{
  onBack?: () => void;
  onNext?: () => void;
  backDisabled?: boolean;
  nextDisabled?: boolean;
  nextLabel?: string;
}> = ({ onBack, onNext, backDisabled = false, nextDisabled = false, nextLabel = 'Next' }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3, px: 2 }}>
      <Button
        onClick={onBack}
        disabled={backDisabled || !onBack}
        variant="outlined"
        startIcon={<ArrowBackIcon />}
        sx={{
          color: '#09273b',
          borderColor: '#09273b',
          borderWidth: '2px',
          textTransform: 'none',
          fontWeight: 600,
          px: 3,
          transition: 'all 0.3s ease',
          '&:hover': {
            borderColor: '#ff5200',
            backgroundColor: '#fff5f0',
            color: '#ff5200',
            borderWidth: '2px',
            transform: 'translateY(-2px)'
          },
          '&:disabled': {
            borderColor: '#e0e0e0',
            color: '#999',
            borderWidth: '1px'
          }
        }}
      >
        Back
      </Button>
      {onNext && (
        <Button
          onClick={onNext}
          disabled={nextDisabled}
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          sx={{
            backgroundColor: '#ff5200',
            color: '#fff',
            textTransform: 'none',
            fontWeight: 600,
            px: 3,
            boxShadow: 'none',
            transition: 'all 0.3s ease',
            '&:hover': {
              backgroundColor: '#e64a00',
              boxShadow: 'none',
              transform: 'translateY(-2px)'
            },
            '&:disabled': {
              backgroundColor: '#ccc',
              color: '#999',
              boxShadow: 'none'
            }
          }}
        >
          {nextLabel}
        </Button>
      )}
    </Box>
  );
};

